export const canMessageProvider = (provider) =>
  Boolean(provider?.provider) && provider?.provider_account_state === "active";

export const buildProviderChatPayload = (provider) => {
  if (!canMessageProvider(provider)) {
    throw new Error("Chat is only available to providers with an active TreatmentFirst account.");
  }
  if (!provider.for_case || !provider.provider.id || !provider.location) {
    throw new Error(
      "Unable to identify this provider’s case or location. Refresh the treatment page and try again."
    );
  }
  return {
    case_id: provider.for_case,
    provider_id: provider.provider.id,
    location_id: provider.location,
    speciality_id: provider.specialty?.id,
  };
};
